import { NgModule } from '@angular/core';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';

import { CelumIconModule } from '@celum/common-components/icon';

import { CelumFormFieldDirective } from './celum-form-field-directive';
import { CelumInlineFormFieldButtons } from './celum-inline-form-field-buttons/celum-inline-form-field-buttons';
import { CelumInlineFormFieldDirective } from './celum-inline-form-field-directive';

@NgModule({
  imports: [CelumFormFieldDirective, CelumInlineFormFieldDirective, CelumInlineFormFieldButtons],
  providers: [
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher
    }
  ],
  exports: [CelumFormFieldDirective, CelumInlineFormFieldDirective, MatInputModule, CelumIconModule, CelumInlineFormFieldButtons]
})
export class CelumInputsModule {}
